export const buildChartJsOptionsProp = (options) => {
  return {
    colors: [
      'var(--color-true-blue-60)',
      'var(--color-salem-60)',
      'var(--color-rhythm-40)',
      'var(--color-fire-engine-red-70)',
      'var(--color-mango-orange-40)'
    ],
    enableTooltip: true,
    deterministic: false,
    fontFamily: "'Inter', 'SF Pro Display', 'Avenir', 'Helvetica Neue', sans-serif",
    fontSizes: [15, 80],
    fontStyle: 'normal',
    fontWeight: 'normal',
    padding: 2,
    rotations: 1,
    rotationAngles: [0, 0],
    scale: 'sqrt',
    spiral: 'rectangular',
    transitionDuration: 1000,
    ...options,
  };
}
